import activities from './activities.js';
import quiz from './quizactivity.js';

export default { ...activities, ...quiz };
